import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import VoletRoulantPilier from "../pages/volet-roulant/page";
import VoletBloque from "../pages/volet-roulant/bloque/page";
import VoletNeRemontePlus from "../pages/volet-roulant/ne-remonte-plus/page";
import ReparationMoteur from "../pages/volet-roulant/reparation-moteur/page";
import ChangerSangle from "../pages/volet-roulant/changer-sangle/page";
import Manivelle from "../pages/volet-roulant/manivelle/page";
import ChangerLame from "../pages/volet-roulant/changer-lame/page";
import Motorisation from "../pages/volet-roulant/motorisation/page";
import VoletSolaire from "../pages/volet-roulant/solaire/page";
import VoletElectrique from "../pages/volet-roulant/electrique/page";
import VitrierPilier from "../pages/vitrier/page";
import RemplacementVitreCassee from "../pages/vitrier/vitre-cassee/page";
import RemplacementDoubleVitrage from "../pages/vitrier/double-vitrage/page";
import DoubleVitrageEmbue from "../pages/vitrier/double-vitrage-embue/page";
import Survitrage from "../pages/vitrier/survitrage/page";
import VitrierUrgence from "../pages/vitrier/urgence/page";
import Miroiterie from "../pages/vitrier/miroiterie/page";
import StorePilier from "../pages/store/page";
import ReparationStoreBanne from "../pages/store/store-banne/page";
import StoreBanneBloque from "../pages/store/store-banne-bloque/page";
import MotorisationStore from "../pages/store/motorisation/page";
import ReparationBSO from "../pages/store/bso/page";
import StoreElectrique from "../pages/store/electrique/page";
import FenetrePilier from "../pages/fenetre/page";
import FenetreBloquee from "../pages/fenetre/bloquee/page";
import ChangerCremone from "../pages/fenetre/cremone/page";
import ChangerPoignee from "../pages/fenetre/poignee/page";
import ReglageOscilloBattant from "../pages/fenetre/oscillo-battant/page";
import ChangerJointFenetre from "../pages/fenetre/joint/page";
import FenetrePvcAluBois from "../pages/fenetre/pvc-alu-bois/page";
import BaieVitreePilier from "../pages/baie-vitree/page";
import BaieVitreeBloquee from "../pages/baie-vitree/bloquee/page";
import ChangerRoulette from "../pages/baie-vitree/roulette/page";
import ReglageBaieCoulissante from "../pages/baie-vitree/reglage/page";
import ReparationPorteCoulissante from "../pages/baie-vitree/porte-coulissante/page";
import SerrureBaieVitree from "../pages/baie-vitree/serrure/page";
import PortePilier from "../pages/porte/page";
import PorteFermeMal from "../pages/porte/ferme-mal/page";
import PorteEntreeBloquee from "../pages/porte/entree-bloquee/page";
import ChangerSerrure from "../pages/porte/changer-serrure/page";
import ChangerBarillet from "../pages/porte/barillet/page";
import SerrurierUrgence from "../pages/porte/urgence/page";
import PorteGarage from "../pages/porte/garage/page";
import MoustiquairePilier from "../pages/moustiquaire/page";
import MoustiquaireFenetre from "../pages/moustiquaire/fenetre/page";
import MoustiquairePorte from "../pages/moustiquaire/porte/page";
import MoustiquaireBaieVitree from "../pages/moustiquaire/baie-vitree/page";
import MentionsLegales from "../pages/mentions-legales/page";
import PolitiqueConfidentialite from "../pages/politique-confidentialite/page";
import Contact from "../pages/contact/page";
import ZoneLyon1e from "../pages/zones/lyon-1e/page";
import ZoneLyon2e from "../pages/zones/lyon-2e/page";
import ZoneLyon3e from "../pages/zones/lyon-3e/page";
import ZoneLyon4e from "../pages/zones/lyon-4e/page";
import ZoneLyon5e from "../pages/zones/lyon-5e/page";
import ZoneLyon6e from "../pages/zones/lyon-6e/page";
import ZoneLyon7e from "../pages/zones/lyon-7e/page";
import ZoneLyon8e from "../pages/zones/lyon-8e/page";
import ZoneLyon9e from "../pages/zones/lyon-9e/page";
import ZoneVilleurbanne from "../pages/zones/villeurbanne/page";
import ZoneCaluire from "../pages/zones/caluire-et-cuire/page";
import ZoneVenissieux from "../pages/zones/venissieux/page";
import ZoneBron from "../pages/zones/bron/page";
import ZoneVaulx from "../pages/zones/vaulx-en-velin/page";
import ZoneSaintPriest from "../pages/zones/saint-priest/page";
import ZoneOullins from "../pages/zones/oullins-pierre-benite/page";
import ZoneSainteFoy from "../pages/zones/sainte-foy-les-lyon/page";
import ZoneTassin from "../pages/zones/tassin-la-demi-lune/page";
import ZoneEcully from "../pages/zones/ecully/page";
import ZoneFrancheville from "../pages/zones/francheville/page";
import ZoneRillieux from "../pages/zones/rillieux-la-pape/page";
import ZoneMeyzieu from "../pages/zones/meyzieu/page";
import ZoneDecines from "../pages/zones/decines-charpieu/page";
import ZoneSaintFons from "../pages/zones/saint-fons/page";
import BlogIndex from "../pages/blog/page";
import BlogCleCassee from "../pages/blog/cle-cassee-dans-serrure/page";
import BlogPorteFermeMal from "../pages/blog/porte-entree-qui-ferme-mal/page";
import BlogChangerSerrure from "../pages/blog/changer-serrure-appeler-pro/page";
import Merci from "../pages/merci/page";
import BlogVRNeRemonte from "../pages/blog/volet-roulant-ne-remonte-plus/page";
import BlogVRBloque from "../pages/blog/volet-roulant-bloque-que-faire/page";
import BlogSangle from "../pages/blog/changer-sangle-volet-roulant/page";
import BlogMoteur from "../pages/blog/moteur-volet-roulant-en-panne/page";
import BlogVitrageEmbue from "../pages/blog/double-vitrage-embue/page";
import BlogFenetreFermeMal from "../pages/blog/fenetre-qui-ferme-mal/page";
import BlogBaieCoince from "../pages/blog/baie-vitree-qui-coince/page";
import BlogMoustSansPercage from "../pages/blog/moustiquaire-fenetre-sans-percage/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  // Silo 1 : Volet roulant
  { path: "/reparation-volet-roulant-lyon/", element: <VoletRoulantPilier /> },
  { path: "/volet-roulant-bloque-lyon/", element: <VoletBloque /> },
  { path: "/volet-roulant-ne-remonte-plus-lyon/", element: <VoletNeRemontePlus /> },
  { path: "/reparation-moteur-volet-roulant-lyon/", element: <ReparationMoteur /> },
  { path: "/changer-sangle-volet-roulant-lyon/", element: <ChangerSangle /> },
  { path: "/manivelle-volet-roulant-lyon/", element: <Manivelle /> },
  { path: "/changer-lame-volet-roulant-lyon/", element: <ChangerLame /> },
  { path: "/motorisation-volet-roulant-lyon/", element: <Motorisation /> },
  { path: "/volet-roulant-solaire-lyon/", element: <VoletSolaire /> },
  { path: "/volet-roulant-electrique-lyon/", element: <VoletElectrique /> },
  // Silo 2 : Vitrier
  { path: "/vitrier-lyon/", element: <VitrierPilier /> },
  { path: "/remplacement-vitre-cassee-lyon/", element: <RemplacementVitreCassee /> },
  { path: "/remplacement-double-vitrage-lyon/", element: <RemplacementDoubleVitrage /> },
  { path: "/double-vitrage-embue-lyon/", element: <DoubleVitrageEmbue /> },
  { path: "/survitrage-lyon/", element: <Survitrage /> },
  { path: "/vitrier-urgence-lyon/", element: <VitrierUrgence /> },
  { path: "/miroiterie-lyon/", element: <Miroiterie /> },
  // Silo 3 : Store
  { path: "/reparation-store-lyon/", element: <StorePilier /> },
  { path: "/reparation-store-banne-lyon/", element: <ReparationStoreBanne /> },
  { path: "/store-banne-bloque-lyon/", element: <StoreBanneBloque /> },
  { path: "/motorisation-store-lyon/", element: <MotorisationStore /> },
  { path: "/reparation-bso-lyon/", element: <ReparationBSO /> },
  { path: "/store-electrique-lyon/", element: <StoreElectrique /> },
  // Silo 4 : Fenêtre
  { path: "/reparation-fenetre-lyon/", element: <FenetrePilier /> },
  { path: "/fenetre-bloquee-lyon/", element: <FenetreBloquee /> },
  { path: "/changer-cremone-fenetre-lyon/", element: <ChangerCremone /> },
  { path: "/changer-poignee-fenetre-lyon/", element: <ChangerPoignee /> },
  { path: "/reglage-oscillo-battant-lyon/", element: <ReglageOscilloBattant /> },
  { path: "/changer-joint-fenetre-lyon/", element: <ChangerJointFenetre /> },
  { path: "/reparation-fenetre-pvc-alu-bois-lyon/", element: <FenetrePvcAluBois /> },
  // Silo 5 : Baie vitrée
  { path: "/reparation-baie-vitree-lyon/", element: <BaieVitreePilier /> },
  { path: "/baie-vitree-bloquee-lyon/", element: <BaieVitreeBloquee /> },
  { path: "/changer-roulette-baie-vitree-lyon/", element: <ChangerRoulette /> },
  { path: "/reglage-baie-vitree-coulissante-lyon/", element: <ReglageBaieCoulissante /> },
  { path: "/reparation-porte-coulissante-lyon/", element: <ReparationPorteCoulissante /> },
  { path: "/serrure-baie-vitree-lyon/", element: <SerrureBaieVitree /> },
  // Silo 6 : Porte / Serrure
  { path: "/depannage-porte-serrure-lyon/", element: <PortePilier /> },
  { path: "/porte-qui-ferme-mal-lyon/", element: <PorteFermeMal /> },
  { path: "/porte-entree-bloquee-lyon/", element: <PorteEntreeBloquee /> },
  { path: "/changer-serrure-lyon/", element: <ChangerSerrure /> },
  { path: "/changer-barillet-cylindre-lyon/", element: <ChangerBarillet /> },
  { path: "/serrurier-urgence-lyon/", element: <SerrurierUrgence /> },
  { path: "/reparation-porte-garage-lyon/", element: <PorteGarage /> },
  // Moustiquaire
  { path: "/moustiquaire-lyon/", element: <MoustiquairePilier /> },
  { path: "/moustiquaire-fenetre-lyon/", element: <MoustiquaireFenetre /> },
  { path: "/moustiquaire-porte-lyon/", element: <MoustiquairePorte /> },
  { path: "/moustiquaire-baie-vitree-lyon/", element: <MoustiquaireBaieVitree /> },
  // Zones d'intervention — Lyon arrondissements
  { path: "/depannage-menuiserie-lyon-1e/", element: <ZoneLyon1e /> },
  { path: "/depannage-menuiserie-lyon-2e/", element: <ZoneLyon2e /> },
  { path: "/depannage-menuiserie-lyon-3e/", element: <ZoneLyon3e /> },
  { path: "/depannage-menuiserie-lyon-4e/", element: <ZoneLyon4e /> },
  { path: "/depannage-menuiserie-lyon-5e/", element: <ZoneLyon5e /> },
  { path: "/depannage-menuiserie-lyon-6e/", element: <ZoneLyon6e /> },
  { path: "/depannage-menuiserie-lyon-7e/", element: <ZoneLyon7e /> },
  { path: "/depannage-menuiserie-lyon-8e/", element: <ZoneLyon8e /> },
  { path: "/depannage-menuiserie-lyon-9e/", element: <ZoneLyon9e /> },
  // Zones d'intervention — Communes Métropole de Lyon
  { path: "/depannage-menuiserie-villeurbanne/", element: <ZoneVilleurbanne /> },
  { path: "/depannage-menuiserie-caluire-et-cuire/", element: <ZoneCaluire /> },
  { path: "/depannage-menuiserie-venissieux/", element: <ZoneVenissieux /> },
  { path: "/depannage-menuiserie-bron/", element: <ZoneBron /> },
  { path: "/depannage-menuiserie-vaulx-en-velin/", element: <ZoneVaulx /> },
  { path: "/depannage-menuiserie-saint-priest/", element: <ZoneSaintPriest /> },
  { path: "/depannage-menuiserie-oullins-pierre-benite/", element: <ZoneOullins /> },
  { path: "/depannage-menuiserie-sainte-foy-les-lyon/", element: <ZoneSainteFoy /> },
  { path: "/depannage-menuiserie-tassin-la-demi-lune/", element: <ZoneTassin /> },
  { path: "/depannage-menuiserie-ecully/", element: <ZoneEcully /> },
  { path: "/depannage-menuiserie-francheville/", element: <ZoneFrancheville /> },
  { path: "/depannage-menuiserie-rillieux-la-pape/", element: <ZoneRillieux /> },
  { path: "/depannage-menuiserie-meyzieu/", element: <ZoneMeyzieu /> },
  { path: "/depannage-menuiserie-decines-charpieu/", element: <ZoneDecines /> },
  { path: "/depannage-menuiserie-saint-fons/", element: <ZoneSaintFons /> },
  // Pages légales
  { path: "/mentions-legales/", element: <MentionsLegales /> },
  { path: "/politique-confidentialite/", element: <PolitiqueConfidentialite /> },
  { path: "/contact/", element: <Contact /> },
  { path: "/merci/", element: <Merci /> },
  { path: "*", element: <NotFound /> },
  // Blog
  { path: "/blog/", element: <BlogIndex /> },
  { path: "/blog/cle-cassee-dans-serrure/", element: <BlogCleCassee /> },
  { path: "/blog/porte-entree-qui-ferme-mal/", element: <BlogPorteFermeMal /> },
  { path: "/blog/changer-serrure-appeler-pro/", element: <BlogChangerSerrure /> },
  { path: "/blog/volet-roulant-ne-remonte-plus/", element: <BlogVRNeRemonte /> },
  { path: "/blog/volet-roulant-bloque-que-faire/", element: <BlogVRBloque /> },
  { path: "/blog/changer-sangle-volet-roulant/", element: <BlogSangle /> },
  { path: "/blog/moteur-volet-roulant-en-panne/", element: <BlogMoteur /> },
  { path: "/blog/double-vitrage-embue/", element: <BlogVitrageEmbue /> },
  { path: "/blog/fenetre-qui-ferme-mal/", element: <BlogFenetreFermeMal /> },
  { path: "/blog/baie-vitree-qui-coince/", element: <BlogBaieCoince /> },
  { path: "/blog/moustiquaire-fenetre-sans-percage/", element: <BlogMoustSansPercage /> },
];

export default routes;